module.exports = __webpack_public_path__ + "static/media/Milan.0ce3070e.png";